// Arabic strings for the demosandbox stream — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until
// decision H-10.
import type { enDemosandbox } from './en-demosandbox.ts';
import type { Message } from './types.ts';

export const arDemosandbox: { readonly [K in keyof typeof enDemosandbox]: Message } = {
  // ------------------------------------------------------------ API (PD-775)
  'api.demoSandboxBusy': 'شخص آخر يجرّب هذا في العرض التجريبي الآن — جرّب زائراً آخر أو انتظر قليلاً.',
  // ------------------------------------------------------------ notices (PD-776)
  'demo.sandbox.title': 'عرض تجريبي: نجح هذا لك وحدك',
  'demo.sandbox.body': 'لم يُحفظ أي شيء. يراه هذا المتصفح فقط، ويُلغى بعد {minutes} دقيقة دون استخدام.',
  'demo.sandbox.fallbackTitle': 'عرض تجريبي: عُرض مرة واحدة ولم يُحتفظ به',
  'demo.sandbox.fallbackBody': 'يجرّب كثيرون العرض التجريبي الآن، لذلك عُرض هذا التغيير مرة واحدة ولم يُحتفظ به. تبدأ الخطوة التالية من جديد من بيانات العرض.',
  // ------------------------------------------------------------ sign-in page list (PD-777)
  'demo.kiosk.samples': 'في الكشك اختر «لدي دعوة»، ثم أدخل أحد أرقام الزيارات التالية والاسم الظاهر:',
  'demo.kiosk.sample': '{reference} مع الاسم {check}',
  // ------------------------------------------------------------ truthful page copy in demo mode (PD-776)
  'demo.pass.rsvpRecorded': 'شكراً لك. في هذا العرض التجريبي يظهر ردّك لك وحدك: لا يُبلَّغ مضيفك ولا يُحتفظ بأي شيء.',
  'demo.kiosk.doneBody': 'في هذا العرض التجريبي لا يُبلَّغ أحد ولا يُحتفظ بأي شيء: يظهر تسجيل حضورك على هذه الشاشة فقط.',
};
